/*import React from 'react'
import './Item.css'
import { Link } from 'react-router-dom'

const Item = (props) => {
  return (
    <div className='item'>
      <Link to={`/product/${props.id}`}><div className='item-box'>
        <img onClick={window.scrollTo(0,0)} src={props.image} alt='' />
        <div className='item-text'>
          <div>
            <p className='name'>{props.name}</p>
            <p className='size'>({props.size}) - {props.color}</p>
          </div>
          <div className="item-prices">
              <div className="item-price-new">
                  ${props.new_price}
              </div>
              <div className="item-price-old">
                  {props.old_price}
              </div>
          </div>
        </div>
        <div className='item-btn'>
          View Product
        </div>
      </div></Link>
    </div>
  )
}
*/
import React from 'react';
import { Link } from 'react-router-dom'
import './Item.css';

const Item = (props) => {
  const itemClass = props.soldOut ? 'item sold-out' : 'item'; 

  return (
    <div className={itemClass}>
      <Link
        to={`/product/${props.id}`}
        onClick={(e) => props.soldOut && e.preventDefault()}
        draggable="false"
        className='item-link'
      >
        <div className='item-box' >
          <img src={props.image} alt='' draggable="false" />
          <div className='item-text'>
            <div>
              <p className='name'>{props.name}</p>
              <p className='size'>({props.size}) - {props.color}</p>
            </div>
            <div className="item-prices">
              <div className="item-price-new">
                ${props.new_price}
              </div>
              <div className="item-price-old">
                {props.old_price}
              </div>
            </div>
          </div>
          {/*<div className='item-btn'>
            {props.soldOut ? 'Sold Out' : 'View Product'}
          </div>*/}
        </div>
      </Link>
    </div>
  );
};

export default Item;